import { useMutation } from "@tanstack/react-query";
import { useBookingsOverviewContext } from "PFApp/booking/parts/overview/context/bookings_overview_context";
import useRowChildrenInvalidate from "PFApp/booking/parts/overview/side_panel_row/queries/use_row_children_invalidate";
import { CalendarMode } from "PFApp/booking/types";
import { reassignBookings, ReassignBookingsPayload } from "PFCore/services/bookings_reassign";

import { useProfileInvalidate } from "../../profile";
import { useBookingInvalidate } from "../use_booking_invalidate";

type UseBookingsReassign = {
  oldProfileId: number | undefined;
  newProfileId: number | undefined;
  roleBookingsIds: number[] | undefined;
  activityId: number | undefined;
};

export const useBookingsReassign = ({
  oldProfileId,
  newProfileId,
  roleBookingsIds,
  activityId
}: UseBookingsReassign) => {
  const { invalidateProfile } = useProfileInvalidate();
  const { invalidate } = useBookingInvalidate();
  const { invalidateByActivityIds } = useRowChildrenInvalidate();
  const { calendarMode } = useBookingsOverviewContext();
  return useMutation(async (payload: ReassignBookingsPayload) => reassignBookings(payload), {
    onSuccess: () => {
      (roleBookingsIds ?? []).forEach(invalidate);
      oldProfileId && invalidateProfile(oldProfileId);
      newProfileId && invalidateProfile(newProfileId);
      calendarMode === CalendarMode.Projects && activityId && invalidateByActivityIds([activityId]);
    }
  });
};
